import PropTypes from 'prop-types';
import React from 'react';

export function TextCapitalized({ text }) {
  return (
    <span style={{ textTransform: 'capitalize' }}>{text.toLowerCase()}</span>
  );
}

TextCapitalized.propTypes = {
  text: PropTypes.string.isRequired,
};
